// src/ecrans/nest-g3.jsx — LES PIÈCES DES ÉCRANS ORCHESTRATEUR ET RÉGLAGES,
// mesurées sur la maquette NEST v677 (couleurs du journal : vert = fait, bon ;
// aubergine = une action attend ; gris = un chiffre à lire).
//
// ⚠️ DETTE À FONDRE : #1760 apporte src/ecrans/nest.jsx, pas encore fusionnée.
// À sa fusion, ces écrans passent à nest.jsx et ce fichier disparaît, sauf
// `Feuille`, que nest.jsx n'a pas (une seule copie, règle 79).

import { useEffect } from "react";

export const COULEURS = Object.freeze({
  encre: "#17211E",
  gris: "#5E6A66",
  grisD: "#6B7672",
  bord: "#E6EAE8",
  fond: "#EEF2EF",
  vert: "#0F7A64",
  vertF: "#0B5A49",
  vertP: "#E8F3EE",
  aub: "#7A2E6E",
  aubTx: "#5E2255",
  aubP: "#F4E7F1",
  aubBord: "#DDC2D7",
});
const C = COULEURS;

const CSS = `
.g3{font-family:Manrope,-apple-system,BlinkMacSystemFont,sans-serif;color:${C.encre};background:${C.fond}}
.g3 *{box-sizing:border-box}
.g3 button{font-family:inherit}
.g3-tete{background:#fff;padding:18px 24px;border-bottom:1px solid ${C.bord}}
.g3-sous{font-size:11.5px;color:${C.grisD};margin:0}
.g3-titre{font-size:19px;font-weight:600;margin:2px 0 0}
.g3-note{font-size:11.5px;color:${C.gris};margin:0;padding:8px 24px;background:#fff;border-bottom:1px solid ${C.bord}}
.g3-tuiles{display:flex;gap:10px;margin-top:12px;flex-wrap:wrap}
.g3-tuile{all:unset;box-sizing:border-box;cursor:pointer;background:${C.vertP};border-radius:12px;padding:10px 14px;min-width:110px}
.g3-tuile b{display:block;font-size:22px;font-weight:600;line-height:1.1;color:${C.vertF}}
.g3-tuile b small{font-size:12px;font-weight:500}
.g3-tuile span{display:block;font-size:11px;color:${C.vertF};margin-top:3px}
.g3-tuile.al{background:${C.aubP}}
.g3-tuile.al b,.g3-tuile.al span{color:${C.aub}}
.g3-tuile:focus-visible,.g3-ligne:focus-visible,.g3-bt:focus-visible{outline:2px solid ${C.vert};outline-offset:2px}
.g3-page{padding:14px 24px 24px;max-width:1000px}
.g3-carte{background:#fff;border:1px solid ${C.bord};border-radius:14px;padding:12px 14px;margin-bottom:10px}
.g3-ligne{all:unset;box-sizing:border-box;cursor:pointer;display:flex;align-items:center;gap:10px;width:100%;background:#fff;border:1px solid ${C.bord};border-radius:12px;padding:9px 12px;margin-bottom:6px;min-height:44px}
.g3-ligne .co{flex:1;min-width:0}
.g3-ligne .t{display:block;font-size:12.5px;font-weight:600}
.g3-ligne .s{display:block;font-size:11px;color:${C.gris};margin-top:2px;overflow-wrap:anywhere}
.g3-ligne .ch{color:${C.grisD}}
.g3-bt{all:unset;box-sizing:border-box;cursor:pointer;display:inline-flex;align-items:center;gap:6px;padding:0 13px;min-height:44px;border-radius:10px;font-size:12px;font-weight:600;background:#fff;border:1px solid #D6DDDA;color:#1C3A33}
.g3-bt.p{background:${C.vert};color:#fff;border-color:transparent}
.g3-inter{font-size:10.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:${C.grisD};margin:14px 0 7px}
.g3-etat{font-size:12px;color:${C.gris};padding:10px 2px;margin:0}
.g3-manque{font-size:11px;color:${C.grisD};font-style:italic;margin:4px 0}
.g3-erreur{display:flex;gap:8px;align-items:flex-start;font-size:12px;color:${C.aubTx};background:${C.aubP};border:1px solid ${C.aubBord};border-radius:10px;padding:9px 11px;margin:6px 0}
.g3-erreur button{all:unset;cursor:pointer;text-decoration:underline;font-weight:600;margin-left:auto;white-space:nowrap}
.g3-seg{display:inline-flex;gap:3px;background:#F2F4F3;border-radius:10px;padding:3px;flex-wrap:wrap}
.g3-seg button{all:unset;cursor:pointer;display:flex;align-items:center;padding:0 13px;min-height:38px;border-radius:8px;font-size:12px;color:${C.gris}}
.g3-seg button.on{background:#fff;color:${C.encre};font-weight:600;box-shadow:0 1px 3px rgba(23,33,30,.12)}
.g3-voile{position:fixed;inset:0;background:rgba(23,33,30,.45);z-index:1100;display:flex;align-items:center;justify-content:center;padding:16px}
.g3-feuille{background:#fff;border-radius:16px;width:min(520px,100%);max-height:86vh;overflow:auto;padding:16px 18px}
.g3-feuilleH{display:flex;align-items:center;gap:10px;margin-bottom:10px}
.g3-feuilleH h3{flex:1;margin:0;font-size:15px;font-weight:600}
.g3-feuilleH button{all:unset;cursor:pointer;width:36px;height:36px;display:flex;align-items:center;justify-content:center;border-radius:9px;background:#F2F4F3}
@media (max-width:640px){
 .g3-tete{padding:16px 15px}.g3-note{padding:8px 15px}.g3-page{padding:12px 15px 24px}
 .g3-tuiles{display:grid;grid-template-columns:1fr 1fr}.g3-tuile{min-width:0}
 .g3-voile{align-items:flex-end;padding:0}.g3-feuille{width:100%;border-radius:18px 18px 0 0}
}
`;

export function StyleG3() {
  return <style>{CSS}</style>;
}

/** Une tuile : `n` vaut « … » en lecture, « — » si on ne sait pas, jamais 0 à la place. */
export function TuileG3({ n, sur, libelle, alerte, onClick, testId }) {
  const corps = (
    <>
      <b>
        {n}
        {sur !== undefined && sur !== null ? <small> / {sur}</small> : null}
      </b>
      <span>{libelle}</span>
    </>
  );
  const classe = `g3-tuile${alerte ? " al" : ""}`;
  if (!onClick)
    return (
      <div className={classe} style={{ cursor: "default" }} data-testid={testId}>
        {corps}
      </div>
    );
  return (
    <button type="button" className={classe} onClick={onClick} data-testid={testId}>
      {corps}
    </button>
  );
}

/** « On lit… » ou l'erreur avec « Réessayer » ; rien quand la lecture a réussi. */
export function EtatG3({ lecture, quoi, onRelire }) {
  if (!lecture || lecture.etat === "ok") return null;
  if (lecture.etat === "lecture")
    return (
      <p className="g3-etat" role="status">
        On lit…
      </p>
    );
  return (
    <div className="g3-erreur" role="alert">
      <span>
        <b>{quoi} : </b>
        {lecture.motif}
      </span>
      {onRelire ? (
        <button type="button" onClick={onRelire}>
          Réessayer
        </button>
      ) : null}
    </div>
  );
}

/** Le lien vers l'ancien écran, tant que le geste n'a pas sa porte. */
export function LienAncienG3({ pour, onClick, testId }) {
  return (
    <button type="button" className="g3-bt" style={{ fontWeight: 500 }} onClick={onClick} data-testid={testId}>
      Ancien écran (pour {pour}) ›
    </button>
  );
}

/** Une feuille : au milieu sur ordinateur, en bas sur téléphone. */
export function Feuille({ titre, onFermer, children, testId }) {
  useEffect(() => {
    const echap = (e) => {
      if (e.key === "Escape") onFermer();
    };
    window.addEventListener("keydown", echap);
    return () => window.removeEventListener("keydown", echap);
  }, [onFermer]);
  return (
    <div className="g3-voile" onClick={onFermer} data-testid="feuille-voile">
      <div className="g3-feuille" role="dialog" aria-modal="true" aria-label={titre} data-testid={testId} onClick={(e) => e.stopPropagation()}>
        <div className="g3-feuilleH">
          <h3>{titre}</h3>
          <button type="button" aria-label="Fermer" title="Fermer" onClick={onFermer}>
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];

/** « 2026-08-23 » → « 23 août » ; « — » si la date est illisible. */
export function dateCourte(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  if (!m) return "—";
  return `${Number(m[3])} ${MOIS[Number(m[2]) - 1]}`;
}

/** « 2026-08-23 » → « Dimanche 23 août » ; « — » si illisible. */
export function dateLongue(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ""));
  if (!m) return "—";
  const j = JOURS[new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12)).getUTCDay()];
  return `${j.charAt(0).toUpperCase()}${j.slice(1)} ${dateCourte(iso)}`;
}

/** « 12 » → « 12 h » ; « 15:30 » → « 15h30 » ; « 11:00 » → « 11h ». */
export function heureCourte(h) {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(h || ""));
  if (!m) return null;
  return m[2] === "00" ? `${Number(m[1])}h` : `${Number(m[1])}h${m[2]}`;
}
